import { render, staticRenderFns } from "./ConversionBasedOnCountTransactionByPhrases.vue?vue&type=template&id=c6245626&scoped=true"
import script from "./ConversionBasedOnCountTransactionByPhrases.vue?vue&type=script&lang=ts"
export * from "./ConversionBasedOnCountTransactionByPhrases.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6245626",
  null
  
)

export default component.exports